import { Skeleton } from "@progress/kendo-react-indicators";
import {
    Grid,
    GridColumn as Column,
    GridToolbar,
} from "@progress/kendo-react-grid";
import "./skeleton.scss";
import { SkeletonHeaderCell } from "./skeleton-headers";

export const SkeletonBody = ({ width = '1338px', rowLength, colLength, addFirstColumnAsIndex = true }) => {
    return (
        <div className="skeleton-container new table-wrapper" style={{ width: width, maxWidth: width }}>
            <Grid
                data={Array.from({ length: rowLength }).map((_, idx) => ({ id: idx }))}
                style={{ border: "none" }}
                cells={{
                    headerCell: SkeletonHeaderCell,
                }}
                scrollable="none"
            >
                {addFirstColumnAsIndex ?
                    (
                        <Column
                            title=""
                            width="50px"
                            cell={(cellItem) => {
                                const isFirstRow = cellItem.dataIndex === 0;
                                return (
                                    <td className="skeleton-cell" data-testid="text-skeleton-column">
                                        <Skeleton
                                            shape="rectangle"
                                            className="skeleton-icon"
                                            animation={isFirstRow ? { type: "wave" } : { type: "pulse" }}
                                        />
                                    </td>
                                );
                            }}
                        />)
                    :
                    (
                        <Column
                            title=""
                            cell={(cellItem) => {
                                const isFirstRow = cellItem.dataIndex === 0;
                                return (
                                    <td className="skeleton-cell" data-testid="text-skeleton-column">
                                        <Skeleton
                                            shape="text"
                                            className="skeleton-text"
                                            animation={isFirstRow ? { type: "wave" } : { type: "pulse" }}
                                        />
                                    </td>
                                );
                            }}
                        />
                    )
                }
                {Array.from({ length: colLength }).map((_, textIdx) => (
                    <Column
                        key={textIdx}
                        title=""
                        cell={(cellItem) => {
                            return (
                                <td className="skeleton-cell" style={{ border: "none" }} data-testid="text-skeleton-column">
                                    <Skeleton
                                        shape="text"
                                        className="skeleton-text"
                                        animation={
                                            { type: "pulse" }
                                        }
                                    />
                                </td>
                            );
                        }}
                    />
                ))}
            </Grid>
        </div>
    );
};